import React, { useMemo } from 'react';
import { Box, Chip, Paper, Typography, CircularProgress } from '@mui/material';
import QuestionCard, { Question } from './QuestionCard.tsx';
// import CommonTable from '../../Shared/Tables/TableV1.tsx';
// import { stringify } from 'querystring';

interface PaginationInfo {
  offset: number;
  limit: number;
  total: number;
  has_next: boolean;
}

interface GeneratedQuestionsTableProps {
  questions: Question[];
  pagination?: PaginationInfo | null;
  loadingMore?: boolean;
  onLoadMore?: () => void;
}

const GeneratedQuestionsTable: React.FC<GeneratedQuestionsTableProps> = ({
  questions,
  pagination,
  loadingMore = false,
  onLoadMore,
}) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 600 }}>
          Total Questions: {pagination ? pagination.total : questions.length}
        </Typography>
      </Box>

      {/* Question cards — uses shared QuestionCard (same UI as QuestionBankView) */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {questions.map((question: Question, index: number) => (
          <QuestionCard
            key={question.question_id || index}
            question={question}
            index={index}
          />
        ))}
      </Box>

      {/* Pagination — Load More */}
      {pagination && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.2,
            mt: 1.5,
            bgcolor: '#FAFAFA',
            border: '1px solid #E0E0E0',
            borderRadius: 2,
          }}
        >
          <Typography sx={{ fontSize: 12, color: '#666' }}>
            Showing <strong>{questions.length}</strong> of <strong>{pagination.total}</strong> questions
          </Typography>

          {pagination.has_next && onLoadMore && (
            <Box
              onClick={!loadingMore ? onLoadMore : undefined}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.8,
                px: 2,
                py: 0.7,
                borderRadius: 1.5,
                bgcolor: loadingMore ? '#E0E0E0' : '#1565C0',
                color: '#fff',
                cursor: loadingMore ? 'default' : 'pointer',
                fontSize: 12,
                fontWeight: 500,
                userSelect: 'none',
                transition: 'background 0.2s',
                '&:hover': { bgcolor: loadingMore ? '#E0E0E0' : '#0D47A1' },
              }}
            >
              {loadingMore && <CircularProgress size={13} sx={{ color: '#fff' }} />}
              {loadingMore ? 'Loading...' : 'Load More'}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default GeneratedQuestionsTable;